<script setup lang="ts">
import type { SpecialBodyProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SpecialBodyProps>(), {})

const app = useNuxtApp()

const sBody = app.$getArticleBody(props.item) // ボディ
</script>

<template>
  <div class="l-container">
    <div
      v-if="sBody"
      class="l-container_contentDetail"
    >
      <div
        class="l-container_contentDetail_text l-blank-icon-none"
        v-html="sBody"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.l-container {
  width: 100%;
  color: var(--color_text_base);

  &_contentDetail {
    margin-bottom: 45px;

    &_text {
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 16px;
      line-height: 1.8;
    }
  }

  &_ui {
    @include responsive.mq_down(sp) {
      padding: 0;
    }

    :deep(h2) {
      color: var(--color_text_base);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 20px;
    }

    :deep(h3) {
      margin-top: 50px;
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 18px;
    }

    :deep(h4) {
      margin-top: 70px;
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 16px;
      font-weight: bold;
    }

    :deep(h5) {
      margin-top: 40px;
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 14px;
      font-weight: bold;
    }

    :deep(h6) {
      margin-top: 40px;
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 13px;
      font-weight: bold;
    }

    :deep(p) {
      margin-top: 24px;
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 16px;
      line-height: 1.93;
    }

    :deep(div) {
      display: flex;
      justify-content: space-between;

      @include responsive.mq_down(sp) {
        display: block;
      }

      figure {
        width: 320px;
        margin-top: 10px;

        @include responsive.mq_down(sp) {
          width: 100%;
        }

        img {
          width: 320px;
          height: 240px;
          margin-top: 20px;

          @include responsive.mq_down(sp) {
            width: 100%;
            max-width: 100%;
            height: auto;
          }
        }

        figcaption {
          margin-top: 9px;
          color: var(--color_text_base);
          font-family: var(--g_font_family_NotoSansCJKjp);
          font-size: 14px;
        }
      }
    }
  }
}
</style>
